import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useMemo } from 'react';
import { Box, Grid, Typography, Tab, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useStore, pluralize, } from '@mcn-platform/models';
import ModuleView from '../item/ModuleView';
const InstructorItemList = ({ instructorName, }) => {
    const [tabValue, setTabValue] = useState('course');
    const tabs = [
        { id: 'course', text: 'Courses' },
        { id: 'program', text: 'Programs' },
        { id: 'microcast', text: 'Microcasts' },
    ];
    const store = useStore();
    const combinedFilter = useMemo(() => {
        const orgId = store.currentPortal?.organizationID ?? '';
        return {
            organizationId: orgId,
            searchInstructors: instructorName?.toLowerCase(),
        };
    }, [store.currentPortal?.organizationID, instructorName]);
    // Lazy-load: only request the active tab's list to avoid 3 parallel GQL calls on mount
    const activeModelName = tabValue;
    const activeCachedList = store.getCachedList(activeModelName, combinedFilter);
    activeCachedList.setRequestedCount(50);
    const getTitle = (cachedList, title) => {
        if (['loading', 'stubbed'].includes(cachedList.syncState)) {
            return `Loading ${pluralize(title)}...`;
        }
        if (cachedList.totalCount < 1) {
            return `No ${pluralize(title)} Available`;
        }
        return '';
    };
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };
    return (_jsx(Box, { sx: { width: '100%', typography: 'body1' }, children: _jsxs(TabContext, { value: tabValue, children: [_jsx(Grid, { container: true, sx: { borderBottom: 1, borderColor: 'divider' }, children: _jsx(Grid, { item: true, lg: 12, children: _jsx(TabList, { onChange: handleChange, "aria-label": "tabs", textColor: "inherit", children: tabs.map((tab) => (_jsx(Tab, { value: tab.id, label: tab.text, className: "siteTabs", sx: {
                                    borderBottom: 0,
                                    p: 0,
                                    mx: 2,
                                    my: 1.5,
                                    minWidth: '50px',
                                    minHeight: '25px',
                                    '&.Mui-selected': {
                                        borderBottom: 1,
                                    },
                                    '&:first-child': {
                                        ml: { xs: 1.5, md: 0 },
                                    },
                                } }, tab.id))) }) }) }), _jsxs(TabPanel, { value: "course", sx: { p: { xs: 2, md: 0 }, py: 3 }, children: [_jsx(Typography, { variant: "h6", sx: { m: 1 }, children: getTitle(activeCachedList, 'Course') }), _jsx(ModuleView, { items: tabValue === 'course' ? activeCachedList.items : [] })] }), _jsxs(TabPanel, { value: "program", sx: { p: { xs: 2, md: 0 }, py: 3 }, children: [_jsx(Typography, { variant: "h6", sx: { m: 1 }, children: getTitle(activeCachedList, 'Program') }), _jsx(ModuleView, { items: tabValue === 'program' ? activeCachedList.items : [] })] }), _jsxs(TabPanel, { value: "microcast", sx: { p: { xs: 2, md: 0 }, py: 3 }, children: [_jsx(Typography, { variant: "h6", sx: { m: 1 }, children: getTitle(activeCachedList, 'Microcast') }), _jsx(ModuleView, { items: tabValue === 'microcast' ? activeCachedList.items : [] })] })] }) }));
};
export default observer(InstructorItemList);
//# sourceMappingURL=InstructorItemList.js.map